function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" {...props}><g fill="none" fillRule="nonzero"><path fill="#365aef" d="M20 0C8.978 0 0 8.933 0 20c0 11.022 8.978 20 20 20s20-8.978 20-20C40 8.933 31.022 0 20 0z" /><path fill="#FFF" stroke="#FFF" d="M27.784 13.245c.637-.73 1.65.334 1.014 1.064-3.534 4.194-7.096 8.327-10.658 12.491-.174.213-.348.396-.522.608-.26.304-.753.274-1.013 0-1.796-1.793-3.592-3.617-5.387-5.41-.666-.668.347-1.763 1.013-1.064a731.607 731.607 0 0 1 4.837 4.863 4122.16 4122.16 0 0 0 10.716-12.552z" /></g></svg>;
});